"use client";
import * as React from "react";
const SvgVerifiedSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m16 8-1.77-2 .24-2.63-2.62-.58L10.47.5 8 1.54 5.53.5 4.15 2.78l-2.62.58L1.77 6 0 8l1.78 2-.25 2.64 2.62.58 1.38 2.28L8 14.45l2.47 1.04 1.38-2.28 2.62-.58-.25-2.64zm-9.39 3.37L3.85 8.65l1.07-1.06 1.69 1.67 4.26-4.2 1.07 1.06z" }));
export {
  SvgVerifiedSharp as default
};
